'use client';

import { Drawer as MUIDrawer } from '@mui/material';

import type { ReactNode } from 'react';

type Anchor = 'left' | 'right' | 'top' | 'bottom';

type DrawerProps = {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
  anchor?: Anchor;
  width?: number | string;
  paperClassName?: string;
  keepMounted?: boolean;
  onExited?: () => void;
};

export function Drawer({
  open,
  onClose,
  children,
  anchor = 'right',
  width = 280,
  paperClassName,
  keepMounted = true,
  onExited,
}: DrawerProps) {
  const inlineWidth =
    anchor === 'left' || anchor === 'right'
      ? typeof width === 'number'
        ? `${width}px`
        : width
      : undefined;
  return (
    <MUIDrawer
      open={open}
      onClose={onClose}
      anchor={anchor}
      ModalProps={{ keepMounted }}
      slotProps={{
        transition: {
          appear: true,
          onExited,
        },
        paper: {
          className: paperClassName,
          style: { width: inlineWidth },
          sx: {
            width: anchor === 'left' || anchor === 'right' ? width : undefined,
            backgroundColor: 'var(--nn-color-foreground)',
            borderRight:
              anchor === 'left'
                ? '1px solid rgba(255 255 255 / 10%)'
                : undefined,
            borderLeft:
              anchor === 'right'
                ? '1px solid rgba(255 255 255 / 10%)'
                : undefined,
            borderBottom:
              anchor === 'top'
                ? '1px solid rgba(255 255 255 / 10%)'
                : undefined,
            borderTop:
              anchor === 'bottom'
                ? '1px solid rgba(255 255 255 / 10%)'
                : undefined,
          },
        },
      }}
    >
      {children}
    </MUIDrawer>
  );
}
